import axiosClient from "../../../api/apiClient";

export const APIPostImportAnswers = (data: object) => {
    return axiosClient.post(`import/test-with-answers`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};